import * as React from 'react';
import { CommentPart } from './parts';

import * as styles from './ReviewComment.css';
import { IComment } from '../../../../types/developerV2/review';
import { ArticleHeading4, UIText1 } from '@cian/ui-kit';

export interface IReviewCommentProps {
  isLegacy: boolean;
  comment: IComment;
  reviewId: string;
  onReadFullReviewClick(reviewId: string): void;
}

export const ReviewComment: React.FC<IReviewCommentProps> = ({
  isLegacy,
  comment,
  reviewId,
  onReadFullReviewClick,
}) => {
  const handleClick = React.useCallback(() => {
    onReadFullReviewClick(reviewId);
  }, [onReadFullReviewClick, reviewId]);

  return (
    <div className={styles['container']}>
      <div className={styles['comment']}>
        {!isLegacy && (
          <div className={styles['type']}>
            <ArticleHeading4>{comment.type}</ArticleHeading4>
          </div>
        )}
        {isLegacy ? (
          <CommentPart message={comment.legacy as string} />
        ) : (
          <>
            <CommentPart title="Плюсы:" message={comment.positive as string} />
            <CommentPart title="Минусы:" message={comment.negative as string} />
          </>
        )}
      </div>
      <button onClick={handleClick} className={styles['button']}>
        <UIText1 color="text-main-default">Читать полностью</UIText1>
      </button>
    </div>
  );
};
